import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconStyleFilterSelected({
  dialogId,
  targetElementId,
  styleTypeOld,
  styleTypeNew,
  tabId,
  premiumAvailable,
}) {
  const traits = {
    dialogId,
    styleTypeOld,
    styleTypeNew,
    tabId,
    premiumAvailable,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_STYLE_FILTER_SELECTED, traits);
}
